<template>
  <div class="foot-logos">
    <div class="foot-lg">
      <img src="@/assets/img/foot/foot-logo.png" alt="">
    </div>
    <div class="foot-contain">
      <div class="contains">
        <div class="sm">
          <div class="title">
            扫码关注
          </div>
          <div class="sm-img">
            <img src="@/assets/img/foot/foot-sm-img.png" alt="">
          </div>
        </div>

        <div class="sm">
          <div class="title">
            提供服务
          </div>
          <div class="sm-text" >
            <div class="sm-text-left">
              <div v-for="(items,index) in footerList1" class="sm-text-contain" @click="clicklist1(index)">
                <router-link :to="items.links">
                  <span style="color: white">{{items.name}}</span>
                </router-link>
              </div>
            </div>
            <div class="sm-text-right">
              <div v-for="(items,index) in footerList2" class="sm-text-contain" @click="clicklist2(index)">
                <router-link :to="items.links">
                  <span style="color: white">{{items.name}}</span>
                </router-link>
              </div>
            </div>

          </div>
        </div>

        <div class="sm">
          <div class="title">
            与我合作
          </div>
          <div class="sm-text">
            <div class="sm-text-left">
              <div class="sm-text-contain ">
                <div class="sm-text-left-top">上海总部</div>
                <div class="sm-text-left-top">联系人：付先生</div>
                <div class="sm-text-left-top">电&nbsp;&nbsp;&nbsp;&nbsp;话：13524065132</div>
                <div class="sm-text-left-top">邮&nbsp;&nbsp;&nbsp;&nbsp;箱：fuyikai@hyaedu.net</div>
                <div>地&nbsp;&nbsp;&nbsp;&nbsp;址：上海市闵行区虹梅南路6001号东海学院传媒学院4楼</div>
              </div>
            </div>
            <div class="sm-text-right">
              <div class="sm-text-contain ">
                <div class="sm-text-left-top">无锡研发中心</div>
                <div class="sm-text-left-top">史先生</div>
                <div class="sm-text-left-top">15504444684</div>
                <div class="sm-text-left-top">shishengyu@hyaedu.net</div>
                <div>江苏省无锡市滨湖区 无锡商会大厦12楼Z28 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot-bottom">
      <div>公司域名  www.hyaedu.net
        &nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;
       备案号
          &nbsp;&nbsp;
        <span @click="openBaweb" style="cursor: pointer;" class="ba">沪ICP备2020031101号-1
          </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      footerList1:[
        {
          name:'TiU Solution',
          links:'tiyou'
        },{
          name:'数字化教材开发',
          links:'szjc'
        },{
          name:'实训室建设',
          links:'sxs'
        },{
          name:'项目申报',
          links:'xmsb'
        }
      ],
      footerList2:[
        {
          name:'AI姿态识别系统',
          links:'ai'
        },{
          name:'校企深度育人',
          links:'xqhz1'
        },{
          name:'赛事服务',
          links:'xqhz2'
        }
      ]
    };
  },
  created() {
  },
  mounted() {
  },
  watch:{
  },
  methods: {
    clicklist1(val){
      this.$router.push()
    },
    clicklist2(val){

    },
      openBaweb(){
          window.open("https://beian.miit.gov.cn/#/Integrated/index",'_blank');
      },
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/footer.scss';

.ba:hover{
  color:white;
}
</style>
